// extracted by mini-css-extract-plugin
export var clickThrough = "_z4-2";
export var fallback = "_z4-5";
export var frame = "_z4-3";
export var frameCell = "_z4-1";
export var overlay = "_z4-4";
export var wrapper = "_z4-0";